import { Component } from '@angular/core'

@Component({
  selector: 'customer-portal-app-login-view',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginViewComponent {}
